<template>
    <div style="background-color: #FAF9F6;" :style="isDesktop() && !selected ? 'padding-bottom: 320px' : '50px'">

        <RovinietaNavigation></RovinietaNavigation>

        <Steps :current-page="2"></Steps>

        <div class="container container-medium">
            <div class="purchase-wrapper">
                <div class="text-center pt-2">
                    <Heading v-if="category" :title="$t('buy_vignette')" :routeName="'cart'" :alignment="'text-center'">
                    </Heading>
                    <p class="pt-3"><span class="main-text">{{ $tc('step', 2) }}: {{ $t('select_the_period') }}</span>
                    </p>
                </div>
            </div>
            <div class="selected-cat">
                <div class="d-flex auto-rov-catA align-items-center black" v-if="category && icons">
                    <div class="icon cat-icon m-0" :class="icons[(category.id - 1)].icon" alt=""></div>
                    <div class="txt">{{ $t('vehicles') }} / {{ capitalize($t('vignetteWord')) }} {{ category.title }}
                    </div>
                </div>
            </div>

            <div class="row cards" v-if="category && !loading">
                <div class="col-md-3 col-6 item-card" v-for="(item, key) in category.prices" :key="key" v-scroll-to="{
                    el: '#form-1',
                    offset: -92, // 92px is the height of the fixed header
                }">
                    <div class="card card-pointer" :class="[{ 'card-primary': valability_key == key && selected }]"
                        @click="chooseValability(key)">
                        <div class="elipse-complete position-absolute margin-minus"
                            v-if="valability_key == key && selected">
                            <div class="icon v-icon"></div>
                        </div>
                        <span class="number-of-passes">{{ item.valability.name }}</span>
                        <p class="card-text"><strong>{{ item.value_ron }}</strong> {{ $tc('currency', item.value_ron) }}
                            ({{ item.value_eur }} EUR)</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container container-xs no-padding-mobile" v-if="form_visible">
            <div id="form-1">
                <template v-if="!loading">
                    <div class="form-group">
                        <label for="fromDate">{{ $t('label_available_from') }}:</label>
                        <span v-if="errorMsgs.fromDate" class="invalid-feedback">
                            {{ errorMsgs.fromDate }}
                        </span>
                        <datepicker class="form-group" :language="getDatepickerTranslationsObj()"
                            :disabled-dates="disabledDates" :bootstrap-styling="true" v-model="fromDate"
                            :class="{ 'has-error': errorMsgs.fromDate }" id="date-picker">
                        </datepicker>
                    </div>
                    <template v-if="!vehicle">
                        <div class="form-group p-relative">
                            <label>{{ $t('label_license_plate') }}</label>
                            <span v-if="errorMsgs.plateNo" class="invalid-feedback">
                                {{ errorMsgs.plateNo }}
                            </span>
                            <input type="text" dusk="license-plate" class="form-control" @keydown.38.prevent
                                @keydown.40.prevent :value="plateNo" @input="e => plateNo = e.target.value"
                                :class="{ 'has-error': errorMsgs.plateNo }">
                            <autocomplete v-if="isLoggedIn && plateNo && showAutocomplete" :search="plateNo"
                                @destroy="destroyAutocomplete" @choose="setSearchedVehicle"></autocomplete>
                        </div>
                        <div class="form-group" v-if="isMandatoryChasis">
                            <label>{{ $t('label_chasis_number') }}</label>
                            <span v-if="errorMsgs.chasisNo" class="invalid-feedback">
                                {{ errorMsgs.chasisNo }}
                            </span>
                            <input type="text" class="form-control" :class="{ 'has-error': errorMsgs.chasisNo }"
                                v-model="chasisNo">
                            <div class="warning-feedback">
                                {{ chasisNumberWarning() }}
                            </div>
                        </div>
                        <div class="form-group" v-if="countries">
                            <label for="taraInmatriculare">{{ $t('label_registration_country') }}</label>
                            <select class="form-control" id="taraInmatriculare" v-model="country">
                                <option v-for="c in countries" :key="c.id" :value="c.id">{{ c.country }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="motivCategorie">{{ $t('label_motif') }} (optional)</label>
                            <input type="text" v-model="reason" class="form-control" id="motivCategorie">
                        </div>
                    </template>
                    <template v-if="vehicle">
                        <div class="form-group" v-if="noChasisOnLoad">
                            <label>{{ $t('label_chasis_number') }}</label>
                            <span class="invalid-feedback">
                                {{ errorMsgs.chasisNo }}
                            </span>
                            <input type="text" class="form-control" :class="{ 'has-error': errorMsgs.chasisNo }"
                                v-model="chasisNo">
                            <div class="warning-feedback">
                                {{ chasisNumberWarning() }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <AddProductForVehicle :vehicle="vehicle" :type="'vignette'" :hide-btn="true">
                            </AddProductForVehicle>
                        </div>
                    </template>
                    <div class="form-group">
                        <label class="sms-notification">
                            <input type="checkbox" v-model="sms_confirm_notification">
                            {{ $tc('sms_confirm_notification', Math.ceil(getSmsSetting.value), { 'price': getSmsSettingMessage() }) }}
                        </label>
                    </div>
                    <div class="form-group">
                        <label class="sms-notification">
                            <input type="checkbox" v-model="sms_expiry_notification">
                            {{ $tc('sms_expiry_notification', Math.ceil(getSmsSetting.value), { 'price': getSmsSettingMessage() }) }}
                        </label>
                    </div>
                    <div class="form-group" v-if="category.prices[valability_key].valability.days > 7">
                        <label class="sms-notification">
                            <input type="checkbox" v-model="cnair_expiry_notification">
                            {{ $t('cnair_expiry_notification') }}
                        </label>
                    </div>
                </template>
            </div>
        </div>
        <div class="container container-xs" v-if="selected">
            <div class="action-button action-button-big-desktop d-flex justify-content-end" v-if="!loading">
                <button type="submit" dusk="add-to-card-desktop" class="btn-purple" @click="addToCart()">
                    <template v-if="!getEditProduct">
                        {{ $t('continue') }}
                    </template>
                    <template v-else>
                        {{ $t('continue') }}
                    </template>
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import Steps from './snippets/Steps.vue'
import CartSummary from './order/CartSummary.vue'
import RovinietaNavigation from './RovinietaNavigation.vue'
import Datepicker from 'vuejs-datepicker'
import { en, de, ro, hu, sr, ru, tr, bg, pl } from 'vuejs-datepicker/dist/locale'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import AddProductForVehicle from './snippets/AddProductForVehicle.vue'
import Heading from './snippets/Heading.vue'
import Autocomplete from './snippets/Autocomplete.vue'

export default {
    name: 'VignetteCategory',
    components: {
        CartSummary,
        RovinietaNavigation,
        Steps,
        Datepicker,
        AddProductForVehicle,
        Heading,
        Autocomplete
    },
    props: {
        id: {
            type: [Number, String],
            default: null
        },
        carId: {
            type: [Number, String],
            default: null
        },
    },
    data: function () {
        return {
            en: en,
            de: de,
            ro: ro,
            hu: hu,
            sr: sr,
            ru: ru,
            tr: tr,
            bg: bg,
            pl: pl,
            form_visible: false,
            selected: false,
            valability_key: 0,
            availableFrom: '',
            plateNo: '',
            count: 0,
            chasisNo: '',
            country: 1,
            reason: '',
            fromDate: '',
            errorMsgs: {
                plateNo: '',
                chasisNo: '',
                fromDate: '',
            },
            loading: true,
            expiryDate: null,
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate() - 1)), // Disable all dates up to specific date
                from: new Date(new Date().setDate(new Date().getDate() + 29)), // Disable all dates after specific date
            },
            noChasisOnLoad: false,
            vehicles: [],
            destAutocomplete: false,
            showAutocomplete: true,
            sms_confirm_notification: 0,
            sms_expiry_notification: 0,
            cnair_expiry_notification: 0
        }
    },
    computed: {
        ...mapState('language', [
            'locale'
        ]),
        ...mapState('vehicles', [
            'vehicle'
        ]),

        ...mapState('vignetteCategories', [
            'category',
            'icons'
        ]),

        ...mapState('countries', [
            'countries'
        ]),

        ...mapState('auth', [
            'isLoggedIn'
        ]),

        ...mapGetters({
            getSmsSetting: 'settings/getSmsSetting',
            getSmsSettingMessage: 'settings/getSmsSettingMessage',
            getMandatoryChassisForVignette: 'settings/getMandatoryChassisForVignette',
            getEditProduct: 'cart/getEditProduct',
            getEditProductIndex: 'cart/getEditProductIndex',
            cart: 'cart/getCart'
        }),

        isMandatoryChasis() {
            if(this.getMandatoryChassisForVignette.includes(this.category.prices[this.valability_key].valability.name)) {
                return true;                
            }

            return false;
        }
    },
    mounted: function () {
        this.init();
        //resetting vehicle
        this.setVehicle(null);
    },
    watch: {
        plateNo: function (newVal, oldVal) {
            this.plateNo = newVal.toUpperCase();
            this.plateNo = this.plateNo.replace(/\W/g, '');

            if (!this.destAutocomplete) {
                this.showAutocomplete = true;
            }
        },
        fromDate: function (newVal, oldVal) {
            this.errorMsgs.fromDate = '';
            this.expiryDate = null;
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name != 'cart') {
                vm.resetEditProduct();
            }
        });
    },
    beforeDestroy() {
        this.resetEditProduct();
    },
    methods: {
        hasChasis() {
            if (!this.vehicle._chasisNo) {
                this.noChasisOnLoad = true;
            }
            else {
                this.chasisNo = this.vehicle._chasisNo;
            }
        },

        /**
         * Returns the translations datepicker object according to locale from vuex store
         */
        getDatepickerTranslationsObj() {
            return this[this.locale];
        },
        async init() {

            await this.getCountries();
            await this.getCategory(this.id);

            try {
                if (this.carId) {
                    await this.getVehicle(this.carId);
                    this.hasChasis();
                }

                this.checkIfEditProductAndInit();

                this.loading = false;

            } catch (err) {
                this.loading = false;
                this.$dialog.alert({
                    'message': this.$t('toll_category_error_loading_car'),
                    'confirmButtonText': this.$t('btn_i_understand')
                });
            }
        },

        checkIfEditProductAndInit() {
            if (this.getEditProduct) {
                let key = this.category.prices.findIndex((price) => {
                    return price.id == this.getEditProduct.priceId;
                });
                this.chooseValability(key);

                this.plateNo = this.getEditProduct.plateNo;
                this.chasisNo = this.getEditProduct.chasisNo;
                this.fromDate = this.getDateObject(this.getEditProduct.fromDate);
                this.country = this.getEditProduct.country;
                this.reason = this.getEditProduct.reason;
                this.sms_confirm_notification = this.getEditProduct.sms_confirm_notification;
                this.sms_expiry_notification = this.getEditProduct.sms_expiry_notification;
                this.cnair_expiry_notification = this.getEditProduct.cnair_expiry_notification;
            }
        },
        toggle(id) {
            $(`#${id}`).toggle();
        },

        ...mapActions('countries', {
            actionGetCountries: 'getCountries'
        }),

        ...mapActions('vignetteCategories', [
            'getCategory'
        ]),

        ...mapActions('vehicles', [
            'getVehicle',
            'addVehicle'
        ]),

        ...mapMutations('vehicles', [
            'setVehicle'
        ]),

        ...mapActions('orders', [
            'postOrder'
        ]),

        ...mapActions('cart', {
            addToCartAction: 'addToCart',
            resetEditProduct: 'resetEditProduct',
            checkIfProductHasActiveVignette: 'checkIfProductHasActiveVignette'
        }),

        async getCountries() {
            if (this.countries == null) {
                try {
                    let response = await this.actionGetCountries();
                } catch (error) {
                    this.$dialog.alert({
                        'message': this.$t('toll_category_error_loading_country'),
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        },

        chasisNumberWarning() {
            if (this.isMandatoryChasis) {
                let valability = this.category.prices[this.valability_key].valability;
                return this.$t('chasis_number_warning', {'label': valability.name});
            }
        },

        async validate() {

            this.clearErrors(this.errorMsgs);

            var ok = true;

            if (!this.fromDate) {
                ok = false;

                this.errorMsgs.fromDate = this.$t('vignette_category_error_fromdate');
            }

            if (this.isMandatoryChasis) {

                if (!this.chasisNo) {

                    ok = false;
                    this.errorMsgs.chasisNo = this.$t('mandatory');
                }
                else if (!this.validateChasisNo(this.chasisNo)) {

                    ok = false;
                    this.errorMsgs.chasisNo = this.$t('invalid');

                    if (this.carId) {
                        this.noChasisOnLoad = true;
                    }
                }
            }
            else {
                this.chasisNo = '';//resetting chassis is not mandatory
                if (this.chasisNo.length > 0 && !this.validateChasisNo(this.chasisNo)) {

                    ok = false;
                    this.errorMsgs.chasisNo = this.$t('invalid');

                    if (this.carId) {
                        this.noChasisOnLoad = true;
                    }
                }
            }

            if (!this.vehicle) {

                if (!this.plateNo) {
                    ok = false;
                    this.errorMsgs.plateNo = this.$t('mandatory');
                }

                let plateNoOk = this.validatePlateNo(this.plateNo, this.country);

                if (!plateNoOk) {
                    ok = false;
                    this.errorMsgs.plateNo = this.$t('invalid_plate_number_message');
                }
            }

            if (this.plateNo.trim()) {
                let intervalOverlap = await this.validateProductInterval({
                    plateNo: this.plateNo,
                    chasisNo: this.chasisNo,
                    fromDate: this.fromDate,
                    days: this.category.prices[this.valability_key].valability.days,
                    category: this.category.id
                });
                if (intervalOverlap) {
                    this.errorMsgs.fromDate = this.$t('overlapping_products')

                    if (this.expiryDate) {
                        this.errorMsgs.fromDate = this.$t('aleady_active_vignette', { 'date': this.expiryDate });
                    }

                    return false;
                }
            }
            return ok;
        },

        async addToCart() {
            let valid = await this.validate();
            if (!valid) {
                return false;
            }
            if (!this.vehicle) {

                let car = {
                    _plateNo: this.plateNo,
                    _chasisNo: this.chasisNo,
                    _country: this.country,
                    _reason: this.reason,
                    _category: this.id,
                    _category_TPF: 0,
                };

                this.setVehicle(car);
            }
            else {

                if (!this.vehicle._chasisNo) {
                    this.vehicle._chasisNo = this.chasisNo;
                }

                this.plateNo = this.vehicle._plateNo;
                this.chasisNo = this.validateChasisNo(this.vehicle._chasisNo) ? this.vehicle._chasisNo : this.chasisNo;
                this.country = this.vehicle._country;
                this.reason = this.vehicle._reason;
            }


            this.insertToCart();
        },

        insertToCart() {
            let product = {
                type: 'vignette',
                productName: this.category.prices[this.valability_key].valability.description,
                plateNo: this.plateNo,
                vehicleId: this.vehicle.id ? this.vehicle.id : 0,
                chasisNo: this.chasisNo,
                fromDate: this.formatDate(this.fromDate),
                country: this.country,
                price: this.category.prices[this.valability_key].value_ron,
                priceId: this.category.prices[this.valability_key].id,
                days: this.category.prices[this.valability_key].valability.days,
                reason: this.reason,
                category: parseInt(this.id),
                category_name: this.category.title,
                category_description: this.category.desc,
                sms_confirm_notification: this.sms_confirm_notification,
                sms_expiry_notification: this.sms_expiry_notification,
                cnair_expiry_notification: this.category.prices[this.valability_key].valability.days > 7 ? this.cnair_expiry_notification : false
            };

            this.addToCartAction(product);
            this.$router.push({ name: 'cart' });
        },

        dateRangeOverlaps(a_start, a_end, b_start, b_end) {
            if (a_start <= b_end && a_end >= b_start) {
                return true;
            }

            return false;
        },

        async validateProductInterval(product) {
            if (this.cart.length) {
                for (let i = 0; i < this.cart.length; i++) {
                    if (this.cart[i].type == 'vignette') {
                        let aStart = this.getDateTimestamp(this.cart[i].fromDate, 0);
                        let aStop = this.getDateTimestamp(this.cart[i].fromDate, this.cart[i].days);

                        let bStart = this.getDateTimestamp(product.fromDate, 0);
                        let bStop = this.getDateTimestamp(product.fromDate, product.days);

                        if (
                            this.cart[i].type == 'vignette' &&
                            this.cart[i].plateNo.toLowerCase() == product.plateNo.toLowerCase() &&
                            this.dateRangeOverlaps(aStart, aStop, bStart, bStop)
                        ) {
                            if (this.getEditProductIndex == null || (this.getEditProductIndex != null && this.getEditProductIndex != i)) {
                                return true;
                            }
                        }
                    }
                }
            }

            try {
                let result = await this.checkIfProductHasActiveVignette(product);
                if (result.data.exists) {
                    this.expiryDate = result.data.expiryDate;
                    return true;
                }
            }
            catch (error) {
                this.$dialog.alert({
                    'message': error.response.data.error.error_msg,
                    'confirmButtonText': this.$t('btn_i_understand')
                });
            }

            return false;
        },

        getDateTimestamp(date, days) {
            let timestamp = new Date(date).getTime();

            if (days == 12) {//this is one year
                timestamp += (365 * 24 * 3600 * 1000); // * 1000 because it's in milliseconds
            } else if (days) {
                timestamp += (days * 24 * 3600 * 1000); // * 1000 because it's in milliseconds
            }

            return timestamp;
        },

        chooseValability(key) {
            this.valability_key = key;
            this.selected = true
            this.form_visible = true;
        },

        validityStartDate(days) {
            var result = new Date();
            result.setDate(result.getDate() + days);
            var dd = String(result.getDate()).padStart(2, '0');
            var mm = String(result.getMonth() + 1).padStart(2, '0');
            var yyyy = result.getFullYear();
            result = dd + '.' + mm + '.' + yyyy;
            return result;
        },

        setSearchedVehicle(vehicle) {
            this.plateNo = vehicle._plateNo;
            this.chasisNo = vehicle._chasisNo;
            this.country = vehicle._country;
            this.showAutocomplete = false;
        },

        destroyAutocomplete() {
            this.destAutocomplete = true;
            setTimeout(() => {
                this.destAutocomplete = false;
            }, 100);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$lightgrey: lightgrey;
$green: #59af54;

.chasis-warning {
    font-size: 12px;
}

.sms-notification {
    cursor: pointer;
}

.p-t-30 {
    padding-top: 30px;
}

.cards {
    padding-top: 40px;
    padding-bottom: 40px;
}

.selected-cat {
    font-weight: 600;
    background-color: #EEEDEC;

    .cat-icon {
        height: 35px;
        width: 80px;
    }

    .cata-icon {
        background-image: url('../media/icons/erovColor/catA.svg');
    }

    .catb-icon {
        background-image: url('../media/icons/erovColor/catB.svg');
    }

    .catc-icon {
        background-image: url('../media/icons/erovColor/catC.svg');
    }

    .catd-icon {
        background-image: url('../media/icons/erovColor/catD.svg');
    }

    .cate-icon {
        background-image: url('../media/icons/erovColor/catE.svg');
    }

    .catf-icon {
        background-image: url('../media/icons/erovColor/catF.svg');
    }

    .catg-icon {
        background-image: url('../media/icons/erovColor/catG.svg');
    }

    .cath-icon {
        background-image: url('../media/icons/erovColor/catH.svg');
    }
}

.purchase-wrapper {
    padding-top: 10px;
    padding-bottom: 10px;
}

.section {
    background-color: #FAF9F6;
    background-position: center;
    background-size: cover;
    padding-bottom: 50px;

    .purchase-wrapper {
        h1 {

            font-weight: 900;
            font-size: 54px;
            margin-top: 87px;
        }
    }
}

.card-valability {
    cursor: pointer;
}

.card {
    position: relative !important;
    border: 1px solid #0F2443 !important;
    border-radius: 3px !important;
    text-align: initial;
    padding: 19px;

    span {

        font-weight: bold;
        font-size: 22px;
    }

    .margin-minus {
        top: -14px;
        right: -16px;
    }

    &:hover {
        border: 3px solid #0F2443 !important;

        &:not(.card-primary) {
            padding: 17px;
        }

        .margin-minus {
            top: -14px;
            right: -16px;
        }
    }
}

.card-primary {
    padding: 17px;
    border: 3px solid #0F2443 !important;
    border-radius: 3px !important;
}

.not-active {
    background-color: #9FA3A9 !important;
}

.auto-rov-catA {
    border-radius: 4px;
    padding-left: 26px;
    padding-top: 10px;
    padding-bottom: 10px;

    .align-center {
        align-items: center;
    }

    .txt {
        margin-left: 17px;
    }
}

#form-1 {
    background-color: #FFFEFD;
    border-radius: 6px;
    padding: 50px;
    margin-bottom: 40px;

    @media only screen and (max-width: 768px) {
        padding: 50px 20px;
    }
}

.vdp-datepicker__calendar {
    background-color: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 3px 6px #C7C7C6 !important;
    width: 335px;
    display: block !important;
    padding: 10px;
    font-family: 'Montserrat', sans-serif;

    .datepicker {
        table {
            margin-top: 20px;
            width: 100% !important;

            thead {
                padding-top: 32px;

                .dow {
                    font-weight: 500 !important;
                    font-size: 14px;

                }

                tr:first-of-type {
                    th {
                        .switch {
                            font-weight: bold;
                        }
                    }
                }

                tr:last-of-type {
                    padding-bottom: 10px;
                    border-bottom: 1px solid #E9E9F0;

                    th {
                        padding-top: 30px;
                        padding-bottom: 10px;

                        .switch {
                            font-size: 14px;
                        }

                    }
                }
            }

            tbody {
                tr {
                    .day {

                        height: 42px;
                        width: 36px;
                        text-align: center;

                        &:hover {
                            cursor: pointer;
                        }
                    }

                    .active {
                        background-color: #4D30FA;
                        border-radius: 60px;
                        color: white;
                        font-weight: bold !important;

                        &:hover {
                            cursor: default;
                        }
                    }

                    .old {
                        color: #C7C7C6 !important;
                    }
                }
            }
        }
    }

    .today {
        background-color: #4D30FA;
        border-radius: 60px;
        color: white;
        font-weight: bold !important;

        &:hover {
            cursor: default;
        }
    }
}

.btn-purple {
    width: 200px;
    height: 60px;
    font-size: 18px;
    margin-bottom: 50px;
}

.modal-header {
    border: 0;
}

@media only screen and (max-width: 768px) {
    .no-padding-mobile {
        padding: 0;
    }

    #form-1 {
        padding: 15px;
    }

    .cards {
        padding-top: 12px;
        padding-bottom: 12px;

        .card {
            padding: 19px 13px;

            &:hover {
                padding: 17px 11px;
            }
        }
    }

    .auto-rov-catA {
        padding-left: 13px;
    }
}
</style>
